module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('a', {
    attrs: {
      "id": "fm03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("*  *  *")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "blockquote1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The realities of the world affected me as visions,\n                and as visions only, while the wild ideas of the land of dreams became, in\n                turn—not the material of my every-day existence—but in very deed that\n                existence utterly and solely in itself.")])]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Edgar Allan Poe, “Berenice”")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Oh, lady bright! Can it be right—")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("This window open to the night?")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("The wanton airs, from the tree-top,")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Laughingly through the lattice drop—")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("The bodiless airs, a wizard rout,")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Flit through thy chamber in and out,")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("And wave the curtain canopy")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("So fitfully—so fearfully—")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Above the closed and fringed lid")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("’Neath which thy slumb’ring soul lies hid,")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("That, o’er the floor and down the wall,")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Like ghosts the shadows rise and fall!")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Oh, lady dear, hast thou no fear?")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Edgar Allan Poe, “The Sleeper”")])]), _c('p', {
    staticClass: "centera"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("*  *  *")]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145ca30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 66
// module chunks = 0